import { render, staticRenderFns } from "./EventReport.vue?vue&type=template&id=79bc2715&scoped=true"
import script from "./EventReport.vue?vue&type=script&lang=js"
export * from "./EventReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bc2715",
  null
  
)

export default component.exports